import React from "react";
import objectPath from "object-path";
import { API_ROOT } from "../../defines";
import { NavLink } from "react-router-dom";
const Sign = ({ data }) => {
  const url = API_ROOT + "/" + objectPath.get(data, "image.0.id");
  const id = objectPath.get(data, "_id");
  return (
    <NavLink
      to={`/order/detail/${id}`}
      className="flex flex-col w-64 bg-white shadow-lg m-2 p-4 rounded-md hover:cursor-pointer hover:border hover:border-primary"
    >
      <div className="text-sm font-medium text-start">
        {objectPath.get(data, "name")}
      </div>
      <img
        src={url}
        className="object-contain w-32 mt-4 self-center"
        crossOrigin="anonymous"
      />
    </NavLink>
  );
};

export default Sign;
